import axios from 'axios';

import { NutriScoreCategoryBaseIngredientCategory } from 'enums/NutriScoreCategory/NutriScoreCategoryBaseIngredientCategory';
import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(
	searchTerm: string,
	pointType: NutriScoreCategoryBaseIngredientCategory | undefined,
	pageIndex: number,
	pageSize: number
): Promise<Optional<ResponseData>> {
	const url = `${SERVICEBASEURL.BACKEND}/NutriScoreBaseIngredientCategoryPoints`;
	const params: Parameter = {
		SearchTerm: searchTerm,
		PointType: pointType,
		PageIndex: pageIndex,
		PageSize: pageSize,
	};
	return axios
		.get(url, {
			params: params,
		})
		.toOptionalMapped((x) => x.data);
}

interface Parameter {
	SearchTerm: string;
	PointType?: NutriScoreCategoryBaseIngredientCategory;
	PageIndex: number;
	PageSize: number;
}

export interface Response {
	data: ResponseData;
}

export type ResponseData = {
	data: NutriScoreBaseIngredientCategoryPoint[];
	pageIndex: number;
	pageSize: number;
	totalCount: number;
	totalPages: number;
	hasPreviousPage: number;
	hasNextPage: number;
};

export type NutriScoreBaseIngredientCategoryPoint = {
	baseIngredientCategoryId: string;
	pointType: NutriScoreCategoryBaseIngredientCategory;
	baseIngredientCategoryName: string | null;
	isPositive: boolean;
	points: Point[];
};

export type Point = {
	points: number;
	minValue: number | null;
};
